module.exports = __webpack_public_path__ + "6072b327a3254f23bb7d0394ab548fcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/registrationLogo.png
// module id = 3258
// module chunks = 0